module.exports = Object.freeze({
  DENIED: "denied",
  GRANTED: "granted",
  PROMPT: "prompt",
});
